import React, { Component } from 'react';
import InternalNavigation from '../InternalNavigation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectors, actions } from '../sagas/reservation/show';
import { actions as refundActions } from '../sagas/refund';
import { actions as indexReservationActions } from '../sagas/reservation/index';
import { Row, Col } from 'react-bootstrap';
import MainDrawer from '../InternalNavigation/drawer';
import _ from 'lodash'
import '../stylesheets/App.css'
import '../stylesheets/showOrder.sass'

class ShowOrder extends Component {
  constructor(props) {
    super(props)
    this.state = {
      drawer: false
    };
    this.props.actions.showReservationActions.showReservation(this.props.match.params.reservation_id)
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  paymentStateToView = () => {
    return {
      'waiting': 'Pending',
      'success': 'Success',
      'canceled': 'Canceled'
    }
  }

  paymentStateButtonText = () => {
    return {
      'waiting': 'Cancel',
      'success': 'Success',
      'canceled': 'Canceled'
    }
  }

  paymentStateButtonAction = () => {
    return {
      'waiting': this.props.actions.refundActions.cancel,
      'success': this.props.actions.refundActions.cancel,
      'canceled': null
    }
  }

  stripeChargePaymentButtonAction = () => {
    return {
      'succeeded': this.props.actions.refundActions.refund,
      'pending': null,
      'failed': null,

    }
  }

  stripeRefundPaymentButtonAction = () => {
    return {
      'succeeded': null,
      'pending': null,
      'failed': null,
    }
  }

  deleteReservation = (id) => {
    console.log("delete")
    this.props.actions.indexReservationActions.deleteReservation(id)
  }

  stripeState = () => {
    return {
      'succeeded': 'Success',
      'pending': 'Pending',
      'failed': 'Failed'
    }
  }

  stripeChargeActionButtonText = () => {
    return {
      'succeeded': 'Refund',
      'pending': 'Pending',
      'failed': 'Failed'
    }
  }

  stripeRefundActionButtonText = () => {
    return {
      'succeeded': 'Successful',
      'pending': 'Pending',
      'failed': 'Failed'
    }
  }

  stripeChargeDisableButtonStates = () => {
    return [ 'pending', 'failed' ]
  }

  stripeRefundDisableButtonStates = () => {
    return ['pending', 'failed', 'succeeded']
  }

  disableButtonStates = () => {
    return [ 'canceled', 'success' ]
  }

  tableLeft = (value) => {
    return(
      <div
        className={'table-left d-inline-block'}> {value} </div>
    )
  }

  render () {
    let reservation = this.props.reservation && this.props.reservation.attributes
    let customer = this.props.reservation
      && this.props.customer(this.props.reservation)
      && this.props.customer(this.props.reservation).attributes
    return (
    <div>
      <MainDrawer
        position={'left'}
        openState={this.state.drawer}
        toggleDrawer={this.toggleDrawer}
        className='drawer'/>
      <InternalNavigation
        toggleDrawer={this.toggleDrawer}/>
        <div className={'show_order'}>
          <div>
            <div className='page-title'>
              { `Order for ${reservation && reservation.fullName}` }
            </div>
            <div style={{ borderRadius: 4, borderStyle: 'solid', borderWidth: 1, width: 630 }}>
              <table style={{ width: 630 }}>
                  { reservation &&
                    customer &&
                  <tbody>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Name') } </td>
                      <td className={'item'}> { reservation.fullName } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Created At') } </td>
                      <td className={'item'}> { reservation.createdAt } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Street Address') } </td>
                      <td className={'item'}> { customer.streetAddress } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Beer Consumption Address') } </td>
                      <td className={'item'}> { reservation.beerConsumption } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Email') } </td>
                      <td className={'item'}> { customer.email } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Date of Birth') } </td>
                      <td className={'item'}> { customer.birthDate } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Phone') } </td>
                      <td className={'item'}> { customer.phoneNumber } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Keg Size') } </td>
                      { reservation.productNamesAndPrices && reservation.productNamesAndPrices.map( product => {
                          return(
                              <td className={'item product'}>
                                <div>
                                  {product.name}
                                </div>
                                <div>
                                  {_.startCase(product.size)}
                                </div>
                                <div>
                                  {product.price}
                                </div>
                                </td>
                          )
                        })
                      }
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Drivers License Number') } </td>
                      <td className={'item'}> { customer.driverLicense } </td>
                    </tr>
                    <tr>
                      <td className={'border-right'}> { this.tableLeft('Estimated Return Date') } </td>
                      <td className={'item'}> { reservation.estimatedReturnOn } </td>
                    </tr>
                </tbody>
                }
              </table>
            </div>

            <button
              onClick={ () => this.deleteReservation(reservation.id) }
              className={ 'button' }>
              Delete Reservation
            </button>

            <div className="refund" style={{marginTop: 30, paddingBottom: 5}}>
              <div className="refund-item" style={{color: '#A0A0A0'}}>
                Activity
              </div>
              <div className="refund-item" style={{color: '#A0A0A0'}}>
                Status
              </div>
              <div className="refund-item">
                &nbsp;
              </div>
            </div>
              { reservation && reservation.depositsInformation && reservation.depositsInformation.map( deposit => {
                  return(
                      <div>
                        <div className={'refund-row deposit'}>
                          <div className={'refund'}>
                            <div className="refund-item">
                              <div>
                                ${Number(deposit.value).toFixed(2)}
                              </div>
                              <div>
                                { deposit.type === 'hand_tap' ? 'Hand Tap Scheduled Payment' : 'Keg Scheduled Payment' }
                              </div>
                            </div>
                            <div className="refund-item">
                              {this.paymentStateToView()[deposit.paymentState]}
                            </div>
                            <div className="refund-item">
                              <button disabled = { this.disableButtonStates().includes(deposit.paymentState) } onClick={ () => this.paymentStateButtonAction()[deposit.paymentState](deposit.id) } className={ this.disableButtonStates().includes(deposit.paymentState) ? 'disabled-button' : 'button' } type="submit">
                                { this.paymentStateButtonText()[deposit.paymentState] }
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                  )
                })
              }
              { reservation && reservation.chargesInformation && reservation.chargesInformation.map( charge => {
                  return(
                      <div>
                        <div className={'refund-row deposit'}>
                          <div className={'refund'}>
                            <div className="refund-item">
                              <div>
                                ${(Number(charge.chargeAmount)).toFixed(2)}
                              </div>
                              <div>
                                Payment
                              </div>
                            </div>
                            <div className="refund-item">
                              {this.stripeState()[charge.chargeStatus]}
                            </div>
                            <div className="refund-item">
                              <button
                                disabled = { (this.stripeChargeDisableButtonStates().includes(charge.chargeStatus) || charge.refunded) }
                                onClick={ () => this.stripeChargePaymentButtonAction()[charge.chargeStatus](charge.id) }
                                className={ (this.stripeChargeDisableButtonStates().includes(charge.chargeStatus) || charge.refunded) ? 'disabled-button' : 'button' }
                                type="submit"
                              >
                                { charge.refunded ? 'Refunded' : this.stripeChargeActionButtonText()[charge.chargeStatus] }
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                  )
                })
              }
              { reservation && reservation.refundsInformation && reservation.refundsInformation.map( refund => {
                  return(
                      <div>
                        <div className={'refund-row deposit'}>
                          <div className={'refund'}>
                            <div className="refund-item">
                              <div>
                                ${(Number(refund.refundAmount)).toFixed(2)}
                              </div>
                              <div>
                                Refund
                              </div>
                            </div>
                            <div className="refund-item">
                              {this.stripeState()[refund.refundStatus]}
                            </div>
                            <div className="refund-item">
                              <button disabled = { this.stripeRefundDisableButtonStates().includes(refund.refundStatus) } onClick={ () => this.stripeRefundPaymentButtonAction()[refund.refundStatus](refund.id) } className={ this.stripeRefundDisableButtonStates().includes(refund.refundStatus) ? 'disabled-button' : 'button' } type="submit">
                                { this.stripeRefundActionButtonText()[refund.refundStatus] }
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                  )
                })
              }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  reservation: selectors.order(store),
  customer: selectors.customer
})

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      showReservationActions: bindActionCreators(actions, dispatch),
      refundActions: bindActionCreators(refundActions, dispatch),
      indexReservationActions: bindActionCreators(indexReservationActions, dispatch)
    }
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)((ShowOrder)));



// WEBPACK FOOTER //
// ./src/Reservations/ShowOrder.jsx